module.exports = __webpack_public_path__ + "img/raman.779624ed.jpg";